import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AvatarUploaderComponent } from './avatar-uploader.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [AvatarUploaderComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatNativeDateModule, MatIconModule, MatButtonModule, MatProgressBarModule],
  exports: [AvatarUploaderComponent]
})
export class AvatarUploaderModule {}
